module.exports = __webpack_public_path__ + "img/edit.5b5a979d.svg";